<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Matriz from "@/components/widgets/network-matriz";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Matriz,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      id: this.$route.params.id || '',
      positions: [],

      loading: false,
      matriz: null,
    };
  },
  methods: {
    getMatriz() {
      this.loading = true;
      this.matriz = null;

      api.get("network/matriz/" + this.id).then((response) => {
        if (response.data.status == "success") {
          this.positions = response.data.positions;
          this.matriz = response.data.matriz;

          if (this.matriz[0] && this.matriz[0].id) {
            this.id = this.matriz[0].id;
          } else {
            this.id = null;
          }
        } else {
          this.matriz = null;
        }

        this.loading = false;
      });
    },
  },
  mounted() {
    this.getMatriz();
  },
  watch: {
    id: function (v) {
      this.$router.push("/network/matriz/" + v);
      this.getMatriz();
    }
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Matriz') }}</h3>
        <p></p>
      </div>
      <div>
        <select v-model="id" class="custom-select mb-1">
          <option v-for="row in positions" :value="row.id" :key="row.id">{{ row.name }}&nbsp;&nbsp;</option>
        </select>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <Matriz :data="matriz"></Matriz>
      </div>
    </div>
  </Layout>
</template>
